import React from 'react';

function SelectionMethodsContent() {
  return (
    <>
      <p>One of RepoPrompt's core features is the ability to selectively include files for context when working with AI models. This helps optimize token usage and improves the quality of AI responses.</p>
      
      <h3>Selecting Files and Folders</h3>
      <ol>
        <li>In the file tree panel, browse to the files or folders relevant to your current task</li>
        <li>Click the checkbox next to a file name to select it (the content will be included in the prompt)</li>
        <li>Click the checkbox next to a folder name to select all files within that folder (including subfolders)</li>
        <li>Selected files will appear as cards in the "Selected Files" panel on the right side</li>
        <li>Deselect items by unchecking their corresponding checkboxes</li>
      </ol>

      <h3>Drag and Drop</h3>
      <p>For quick file selection from your system:</p>
      <ul>
        <li>Drag files or folders from Finder/Explorer directly onto the RepoPrompt window</li>
        <li>Dropped items will be added to your workspace and automatically selected</li>
      </ul>
      
      <h3>Selection Best Practices</h3>
      <ul>
        <li><strong>Be selective:</strong> Only include files directly relevant to your query</li>
        <li><strong>Watch token limits:</strong> Monitor the token count at the bottom of the window</li>
        <li><strong>Include related files:</strong> Add interface/type definition files that help understand structure</li>
        <li><strong>Consider Code Maps:</strong> For large files, consider using Code Maps instead of full content</li>
      </ul>
      
      <div className="tip-box">
        <strong>Tip:</strong> Selecting only the most relevant files not only saves tokens but also improves the focus and quality of the AI's response by reducing noise. For complex tasks, prioritize including files that define core interfaces or types first.
      </div>
    </>
  );
}

export default SelectionMethodsContent;